import React from 'react'

import './PageHeaderStyles.less'

interface PageHeaderProps {
  title: string
  subtitle?: string
  content: string
}

const Display = (props: PageHeaderProps) => {
  return (
    <div>
      <h3 className="page-header__title">{props.title}</h3>
      {props.subtitle && <h2 className="page-header__subtitle">{props.subtitle}</h2>}
      <h6 className="page-header__content">{props.content}</h6>
    </div>
  )
}

export default Display
